// @mui material components
import Card from "@mui/material/Card";
import SendIcon from "@mui/icons-material/Send";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
// Soft UI Dashboard React components
import { useAlert } from "react-alert";
import ModeEditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import React, {
  useEffect,
  useReducer,
  useState,
  Fragment,
  useRef,
} from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
  Checkbox,
  Divider,
} from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import ReactSelect from "react-select";
import LoadingButton from "@mui/lab/LoadingButton";
import { Input } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Backdrop } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Controller, useForm } from "react-hook-form";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
// import PlusIcon from '@heroicons/react/24/solid/PlusIcon';
import AddIcon from "@mui/icons-material/Add";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Download from "@mui/icons-material/Download";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PermIdentity from "@mui/icons-material/PermIdentity";
import WorkOutline from "@mui/icons-material/WorkOutline";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { DataGrid } from "@mui/x-data-grid";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DialogTitle from "@mui/material/DialogTitle";
// import Avatar from 'react-avatar'
import Avatar from "@mui/material/Avatar";
import fileDownload from "js-file-download";
import Tooltip from "@mui/material/Tooltip";
import Moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContantsRegistration from "./ContantsRegistration";

const Documents = (props) => {
  document.title = "Documents | LuxBillingEHR";

  // console.log('Documents List _________________________+++=', props)
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const fileTypes = ["JPEG", "PNG", "GIF"];
  const alert = useAlert();
  const [tabValue, settabValue] = React.useState(0);
  const [docslist, setdocslist] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [docError, setdocError] = useState(false);
  // const handleClosee = () => setOpen(false)
  const [submitting, setSubmitting] = useState(false);
  const [date, setdate] = React.useState(Moment().format("YYYY-MM-DD"));
  const [base64, setbase64] = useState("");
  const [DocumentName, setDocumentName] = useState("");

  const [patientId, setpatientId] = useState(
    props.patientid !== undefined ? props.patientid : 0
  );
  const [columnID, setcolumnID] = useState(
    props.columnID !== undefined ? props.columnID : 0
  );
  const [AuthorizationFormByCPTid, setAuthorizationFormByCPTid] = useState(
    props.AuthorizationFormByCPTid !== undefined
      ? props.AuthorizationFormByCPTid
      : 0
  );

  console.log("columnIDdoc", columnID);
  const [AutpattientID, setAutpattientID] = useState(props.AutpattientID);
  console.log("test", AutpattientID);
  // const columnID = props.columnID
  const [type, setType] = useState(props.type);

  // const type = props.type
  const [opendocs, setopendocs] = useState(false);
  const [urlFile, seturlFile] = useState("");
  const [urldownload, seturldownload] = useState("");
  const [DocName, setDocName] = useState("");
  const [FullDocName, setFullDocName] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [file, setFile] = useState(null);

  const [filename, setfilename] = useState([]);
  const [base64Data, setBase64Data] = useState([]);
  const [totalProgress, setTotalProgress] = React.useState(0);
  const [savedFiles, setSavedFiles] = React.useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const inputRef = useRef(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [cellid, setcellid] = useState("");

  const handleClickOpen = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  //Modal
  const handleDeleteById = () => {
    const postData = {
      id: cellid,
      deleted: true,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocument`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setRefresh(!refresh);
        setOpenAlert(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const fields = [
    "id",
    "documentName",
    "fileUrl",
    "patientId",
    "practiceId",
    "deleted",
    "date",
    "createdBy",
    "clientCreatedDate",
    "updatedBy",
    "clientUpdatedDate",
    "createdDate",
    "updatedDate",
    "base64",
    "authId",
    "authorizationcptId",
    "notificationId",
    "type",
    "referringProvider",
    "referringPhysiciansId",
  ];
  const defValues = {
    id: 0,
    documentName: "",
    fileUrl: "",
    patientId: 0,
    practiceId: "",
    date: "",
    createdBy: "",
    referringProvider: "",
    referringPhysiciansId: 0,
    Deleted: false,
    clientCreatedDate: "",
    updatedBy: "",
    clientUpdatedDate: "",
    createdDate: "",
    updatedDate: "",
    base64: "",
    authorizationcptId: AuthorizationFormByCPTid,
    notificationId: "",
    authId: columnID,
    type: type,
  };
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);
  const [DocumentData, setDocumentData] = useState(null);
  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      documentName: cell.row.documentName,
      date: cell.row.date,
      id: Delbyid,
      deleted: true,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocument?patientId=${AutpattientID}`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        setRefresh(!refresh);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
  };
  const [EditTime, setEditTime] = useState(false);
  const [Fileurl, setFileurl] = useState(null);
  const [EditTimePayload, setEditTimePayload] = useState(null);
  const [selectedPaths, setSelectedPaths] = useState([]);
  const [downloadLoading, setDownloadLoading] = useState(false); // for spinner
  const handleCheckboxClick = (fileUrl, documentName) => {
    setSelectedPaths((prev) => {
      const exists = prev.find((item) => item.fileUrl === fileUrl);
      if (exists) {
        return prev.filter((item) => item.fileUrl !== fileUrl); // remove
      } else {
        return [...prev, { fileUrl, documentName }]; // add
      }
    });
  };

  const handleDownloadEachDocument = async () => {
    setDownloadLoading(true);
    try {
      for (const item of selectedPaths) {
        const { fileUrl, documentName } = item;
        const encodedPath = encodeURIComponent(fileUrl);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${encodedPath}`,
          {
            headers,
            responseType: "blob",
          }
        );

        // Use original document name if available, fallback to default
        const filename = documentName || `Document_${Date.now()}.pdf`;
        fileDownload(response, filename);
      }

      setSelectedPaths([]); // Clear selection after success
    } catch (error) {
      console.error("Error downloading documents:", error);
    } finally {
      setDownloadLoading(false);
      setSpinner(false);
      setSubmitting(false);
    }
  };
  const [openFax, setOpenFax] = useState(false);
  const [loadingFax, setLoadingFax] = useState(false);
  const [faxNumber, setFaxNumber] = useState("");
  const [faxSubject, setfaxSubject] = useState("");
  const handleOpenFax = () => {
    // Validate selected files before opening fax modal
    const invalidFiles = selectedPaths.filter(
      (item) =>
        !item.fileUrl.toLowerCase().endsWith(".pdf") &&
        !item.fileUrl.toLowerCase().endsWith(".png")
    );

    if (invalidFiles.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid File Type",
        html: `Only <b>PDF</b> and <b>PNG</b> files can be faxed.<br><br>
             The following files are not allowed:<br>
             <ul style="text-align:left; margin-top:10px;">
               ${invalidFiles
                 .map((f) => `<li>${f.documentName || f.fileUrl}</li>`)
                 .join("")}
             </ul>`,
        confirmButtonColor: "#d33",
        didOpen: () => {
          const swalEl = document.querySelector(".swal2-container");
          if (swalEl) swalEl.style.zIndex = "3000";
        },
      });
      return; // Stop here — don't open fax modal
    }

    // ✅ If all valid, open the fax modal
    setOpenFax(true);
  };

  const handleCloseFax = () => {
    setFaxNumber("");
    setfaxSubject("");
    setSelectedPaths([]);
    setOpenFax(false);
  };
  const [error, setError] = useState("");

  const handleFaxChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // remove all non-numeric characters
    setFaxNumber(value);

    if (value.length > 0 && value.length !== 10) {
      setError("Fax number must be exactly 10 digits");
    } else {
      setError("");
    }
  };

  const handleSendFax = async () => {
    if (!faxNumber) {
      setError("Fax number is required");
      return;
    }
    if (faxNumber.length !== 10) {
      setError("Fax number must be exactly 10 digits");
      return;
    }

    try {
      setLoadingFax(true);

      // Prefix fax number with "1"
      const formattedFax = `1${faxNumber}`;

      // Collect all file URLs from selectedPaths
      const documentPaths = selectedPaths.map((item) => item.fileUrl);

      // Prepare payload
      const payload = {
        faxNumber: formattedFax,
        faxText: faxSubject,
        documentPaths: documentPaths,
      };

      console.log("📤 Sending Fax Payload:", payload);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Fax/SendFaxFromDocuments`,
        payload,
        { headers }
      );

      const apiResponse = response;
      let errorMessage = "";
      setSelectedPaths([]);
      // 🔍 Check if portalResponse exists
      if (apiResponse.portalResponse) {
        try {
          const parsedPortalResponse = JSON.parse(apiResponse.portalResponse);

          if (parsedPortalResponse.Status === "Failed") {
            errorMessage = parsedPortalResponse.Result;
          }
        } catch (parseError) {
          console.error("Error parsing portalResponse:", parseError);
        }
      }
      if (errorMessage) {
        Swal.fire({
          icon: "error",
          title: "Fax Failed",
          text: errorMessage,
          confirmButtonColor: "#d33",
          didOpen: () => {
            const swalEl = document.querySelector(".swal2-container");
            if (swalEl) swalEl.style.zIndex = "3000"; // keep above MUI modal
          },
        });
        return;
      }
      Swal.fire({
        icon: "success",
        title: "Fax Sent Successfully!",
        text: "Your fax has been successfully sent.",
        confirmButtonColor: "#3085d6",
        didOpen: () => {
          const swalEl = document.querySelector(".swal2-container");
          if (swalEl) swalEl.style.zIndex = "3000";
        },
      });

      handleCloseFax();
    } catch (error) {
      console.error("Fax sending failed:", error);
      Swal.fire({
        icon: "error",
        title: "Fax Sending Failed",
        text:
          error?.response?.data?.message ||
          "An unexpected error occurred. Please try again.",
        confirmButtonColor: "#d33",
        didOpen: () => {
          const swalEl = document.querySelector(".swal2-container");
          if (swalEl) swalEl.style.zIndex = "3000";
        },
      });
    } finally {
      setLoadingFax(false);
    }
  };

  const appointmentDocslist = [
    {
      field: "Select",
      headerName: "Select",
      sortable: true,
      headerClassName: "super-app-theme--header",
      renderCell: (cellValues) => (
        <Checkbox
          checked={selectedPaths.some(
            (item) => item.fileUrl === cellValues.row.fileUrl
          )}
          disabled={!cellValues.row.fileUrl}
          onClick={() =>
            handleCheckboxClick(
              cellValues.row.fileUrl,
              cellValues.row.documentName
            )
          }
          color="primary"
        />
      ),
    },
    {
      field: "documentName",
      headerName: "Document Name",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (cellValues) => (
        <>
          <Tooltip title={`${cellValues.value}`} placement="left">
            <div>
              <Button
                  disabled={!cellValues.row.fileUrl}
                onClick={() => {
                  setopendocs(true);
                  // seturlFile(cellValues.row.fileUrl)
                  var url = cellValues.row.fileUrl;
                  seturldownload(cellValues.row.fileUrl);
                  axios
                    .get(
                      `${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${url}`,
                      {
                        headers,
                      }
                    )
                    .then((response) => {
                      // setisLoading(false)
                      seturlFile(response);
                    })
                    .catch((error) => {
                      console.error("There was an error!", error);
                    });
                  var arr = cellValues.row.documentName.split(".");
                  console.log("CheckAAAAA", cellValues.row.fileUrl);
                  setDocName(arr.length > 0 ? arr[1].toLowerCase() : "");
                  setFullDocName(cellValues.row.documentName);
                  // console.log('pic flied::', cellValues.row.documentName)
                }}
              >{`${cellValues.value}`}</Button>
            </div>
          </Tooltip>
        </>
      ),
    },
    // {
    //   field: 'physicianName',
    //   headerName: ' Referring Physician ',
    //   sortable: true,
    //   headerClassName: 'super-app-theme--header',
    //   flex: 0.5
    // },
    ...(type == "lomn"
      ? [
          {
            field: "physicianName",
            headerName: "Referring Physician",
            sortable: true,
            headerClassName: "super-app-theme--header",
            flex: 0.5,
          },
        ]
      : []),
    {
      field: "date",
      headerName: "Document Date",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.7,
    },
    {
      field: "Edit",
      headerName: "Edit",
      headerClassName: "super-app-theme--header",
      flex: 0.5,
      renderCell: (cellValues) => (
        <>
          <Tooltip title={`${cellValues.value}`} placement="left">
            <div>
              <Button
                onClick={() => {
                  setOpen(true);
                  setEditTime(true);
                  let RowId = cellValues.row.id;
                  axios
                    .get(
                      `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocumentById?Id=${RowId}`,
                      {
                        headers,
                      }
                    )
                    .then((response) => {
                      setDocumentName(response.documentName);
                      var dateto12 = Moment(response.date).format("YYYY-MM-DD");
                      setdate(dateto12);
                      setEditTimePayload(response);
                      setDocumentData(response.fileUrl);
                      setReferringid(response.referringPhysiciansId);
                      setFileurl(response.fileUrl);
                    })
                    .catch((error) => {
                      console.error("There was an error!", error);
                    });
                }}
              >
                <EditIcon />
              </Button>
            </div>
          </Tooltip>
        </>
      ),
    },
    {
      field: "delete",
      headerClassName: "super-app-theme--header",
      headerName: "Action",
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cell) => (
        <>
          <DeleteIcon
            style={{
              marginRight: "5px",
              float: "right",
              marginTop: "5px",
              color: "red",
              cursor: "pointer",
            }}
            color="black"
            onClick={() => {
              setDialogOpen(true);
              setDelbyid(cell.row.id);
            }}
          ></DeleteIcon>
          <Dialog
            open={isDialogOpen}
            onClose={() => setDialogOpen(false)}
            aria-labelledby="delete-dialog-title"
            BackdropComponent={Backdrop}
            BackdropProps={{
              invisible: true,
            }}
            sx={{ zIndex: 1750 }}
            PaperProps={{
              style: {
                marginRight: "5px",
                float: "right",
                marginTop: "5px",
                color: "red",
                cursor: "pointer",
              },
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Center horizontally
                justifyContent: "center", // Center vertically
                borderRadius: "8px",
                width: "500px",
              }}
            >
              <ErrorOutlineIcon style={{ fontSize: "100px", color: "red" }} />
              <DialogTitle
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: " 1.25rem",
                }}
              >
                Are you sure?
              </DialogTitle>
              <h5
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "normal",
                  color: "#444444",
                }}
              >
                You won't be able to revert this!
              </h5>
              <DialogContent>
                <DialogContentText>
                  <Grid style={{ marginTop: "1rem" }}>
                    <Button
                      onClick={() => setDialogOpen(false)}
                      style={{
                        backgroundColor: "#6c7c84",
                        color: "white",
                        marginBottom: "1rem",
                      }}
                    >
                      No,cancel!
                    </Button>
                    <Button
                      onClick={() => handleDelete(cell)}
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        marginLeft: "1rem",
                        marginBottom: "1rem",
                        border: "1px solid #b4acec",
                      }}
                    >
                      Yes,delete it!
                    </Button>
                  </Grid>
                </DialogContentText>
              </DialogContent>
            </div>
          </Dialog>
        </>
      ),
    },
  ];

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues,
  });

  const handleOpenn = () => {
    setOpen(true);
    setSubmitting(false);
    setbase64("");
    setfilename("");
  };

  const handleChange = (event, newValue) => {
    settabValue(newValue);
  };
  const navigate = useNavigate();
  // console.log('Reading------------------------------------', urlFile)
  const handleDetails = () => {};
  function applyRefresh() {
    setRefresh(!refresh);
    // setOpen(false)
  }
  const handleClose = () => {
    setopendocs(false);
    setFile(null);
    setOpen(false);
    setSubmitting(false);
    // setopenAppcreate(false)
    setRefresh(true);
    setfilename([]);
    setBase64Data([]);
    setDocumentName("");
    setdate("");
    setReferringid("");
    setEditTimePayload(null);
    setEditTime(false);
  };

  // list of documents
  const [referringid, setReferringid] = useState(0);

  useEffect(() => {
    // window.alert('abc')
    if (patientId == undefined) {
      return;
    }
    setSpinner(true);
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/PatientDocument/PatientDocumentList?patientId=${patientId}&authId=${columnID}&type=${type}&notificationId=${0}&authorizationcptId=${AuthorizationFormByCPTid}`,
        { headers }
      )
      .then((response) => {
        fields.forEach((field) => {
          setValue(field, response[field]);
        });
        setSpinner(false);
        setdocslist(response);
      })

      .catch((error) => {
        setSpinner(false);
        console.error("There was an error!", error);
      });
  }, [refresh, columnID]);

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
    "& .MuiDataGrid-row": {
      height: "auto",
    },
    "& .MuiDataGrid-main": {
      minHeight: "100%",
    },
  };
  const styleofmodal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 950,
    // height: 500,
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    p: 4,
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "70vh", // Fixed height using viewport units (or you can use px like "600px")
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    overflowY: "auto", // This enables vertical scrolling when content overflows
    maxHeight: "90vh", // Optional: prevents the modal from becoming too tall
    zIndex: 1600,
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const [sizeError, setSizeError] = useState(false);
  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
  const handleChangeforfile = async (files) => {
    const newFilenames = [];
    const newBase64Data = [];

    setSizeError(false);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Validate file size (10 MB limit)
      if (file.size > MAX_FILE_SIZE) {
        setSizeError(true);
        return; // Stop processing if any file is too large
      }

      const base64 = await fileToBase64(file);
      newFilenames.push(file.name);
      newBase64Data.push(base64);
    }

    setfilename(newFilenames);
    setBase64Data(newBase64Data);
    setdocError(false);
  };

  // onSubmit for single and multiple files
  const [referringError, setReferringError] = useState(false);

  const onSubmit2 = (data) => {
    setSubmitting(true);
    if (EditTime) {
      if ((!DocumentName || !date) && type !== "lomn") {
        setdocError(true);
        setSubmitting(false);
        return; // 🔴 This causes early return
      } else {
        setdocError(false);
      }
    }

    if (!EditTime) {
      if ((base64Data.length <= 0 || !date) && type !== "lomn") {
        setdocError(true);
        setSubmitting(false);
        return; // 🔴 This causes early return
      } else {
        setdocError(false);
      }
    }

    // if (EditTime) {
    //   if (!DocumentName || !date) {
    //     setdocError(true);
    //     setSubmitting(false);
    //     return;
    //   } else {
    //     setdocError(false);
    //   }
    // } else {
    //   if (base64Data.length <= 0 || !date) {
    //     setdocError(true);
    //     setSubmitting(false);
    //     return;
    //   } else {
    //     setdocError(false);
    //   }
    // }
    if (type === "lomn" && !referringid) {
      setReferringError(true);
      setSubmitting(false);
      return;
    }
    if (sizeError) {
      setSizeError(true);
      return;
    }
    setSavedFiles([]);

    const postData = [];
    let totalLength = 0;
    console.log("___________columnID: ", columnID);
    console.log("___________columnID Check: ", columnID > 0);
    let _authId =
      columnID > 0 ? columnID : props.callingFrom == "test" ? -10 : -9;
    let callingFrom = props.callingFrom;
    if (callingFrom == "notifcation") {
      _authId = 0;
    }
    if (callingFrom == "AuthorizationFormByCPT") {
      _authId = -9;
    }
    if (!EditTime) {
      if (type === "lomn" && base64Data.length <= 0) {
        const documentData = {
          patientId:
            props.callingFrom === "Patient" || props.callingFrom === "Patient1"
              ? AutpattientID
              : props.callingFrom === "notifcation"
              ? patientId
              : props.callingFrom === "HealthRequest"
              ? AutpattientID
              : patientId,
          date: date,
          documentName: filename,
          base64:
            base64Data && base64Data.length > 0 && base64Data[0]
              ? base64Data[0]
              : "",
          authId: _authId,
          type: type,
          referringPhysiciansId: referringid,
          notificationId: props.callingFrom == "notifcation" ? -9 : 0,
          authorizationcptId:
            props.callingFrom == "AuthorizationFormByCPT" ? -9 : 0,
        };
        postData.push(documentData);
      } else {
        for (let i = 0; i < base64Data.length; i++) {
          const documentData = {
            patientId:
              props.callingFrom === "Patient" ||
              props.callingFrom === "Patient1"
                ? AutpattientID
                : props.callingFrom === "notifcation"
                ? patientId
                : props.callingFrom === "HealthRequest"
                ? AutpattientID
                : patientId,
            // patientId:AutpattientID,
            date: date,
            documentName: filename[i],
            base64: base64Data[i],
            authId: _authId,
            type: type,
            referringPhysiciansId: referringid,
            // authId:(props.callingFrom=="notifcation"?:-9),
            notificationId: props.callingFrom == "notifcation" ? -9 : 0,
            // authId:(props.callingFrom==""?0:-9),
            authorizationcptId:
              props.callingFrom == "AuthorizationFormByCPT" ? -9 : 0,

            // authorizationcptId:( props.callingFrom=="AuthorizationFormByCPT"? AuthorizationFormByCPTid>0?AuthorizationFormByCPTid:-9
            //  :0),
          };

          postData.push(documentData);
          totalLength += base64Data[i].length;
        }
      }
    } else {
      const documentData = {
        id: EditTimePayload.id,
        patientId:
          props.callingFrom === "Patient" || props.callingFrom === "Patient1"
            ? AutpattientID
            : props.callingFrom === "notifcation"
            ? patientId
            : props.callingFrom === "HealthRequest"
            ? AutpattientID
            : patientId,
        // patientId:AutpattientID,
        date: date || EditTimePayload.date,
        documentName: DocumentName, // Assuming a single file
        base64: base64Data[0], // Assuming a single file
        authId: EditTimePayload.authId,
        // type: type || EditTimePayload.type,
        type: type,
        referringPhysiciansId:
          referringid || EditTimePayload.referringPhysiciansId,
        // authId:(props.callingFrom=="notifcation"?:-9),
        notificationId: props.callingFrom == "notifcation" ? -9 : 0,
        // authId:(props.callingFrom==""?0:-9),
        authorizationcptId:
          props.callingFrom == "AuthorizationFormByCPT" ? -9 : 0,
        fileurl: Fileurl,
      };
      postData.push(documentData);
    }

    const requests = postData.map((documentData, index) => {
      const config = {
        onUploadProgress: function (progressEvent) {
          const progress = Math.round(
            (progressEvent.loaded / totalLength) * 1.5
          );
          if (progress <= 100) {
            setTotalProgress(progress);
          } else {
            setTotalProgress(100);
          }
        },
        headers,
      };
      return axios
        .post(
          `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocument?patientId=${patientId}`,
          documentData,
          config
        )
        .then((response) => {
          //  window.alert('documentData')
          // Update the savedFiles state with the index of the saved file
          setSavedFiles((savedFiles) => [...savedFiles, index]);
          setType(response.type);
          setSpinner(false);
          setOpen(false);
          setSubmitting(false);
          handleClose();
          if (response) {
            // toast.success('Document uploaded successfully.', {
            //   position: "top-center",
            //   hideProgressBar: false,
            //   closeOnClick: false,
            //   pauseOnHover: false,
            //   draggable: false,
            //   progress: undefined,
            //   theme: "light",
            alert.success("Document uploaded successfully.", {
              type: "success",
              onClose: () => {
                if (props.callingFrom == "Patient") {
                  setcolumnID(response.authId);
                  props.updateHealthHistory(
                    response.id,
                    response.authId,
                    response.referringPhysiciansId,
                    response.createdBy,
                    response.createdDate
                  );
                  console.log("checktype", response.authId);
                  props.handleClose222();
                } else if (props.callingFrom == "HealthRequest") {
                  setcolumnID(response.authId);
                  props.updateHealthHistory(response.id, response.authId);
                  console.log("checktype", response.authId);
                  props.handleClose222();
                } else if (props.callingFrom == "AuthorizationFormByCPT") {
                  setcolumnID(response.authId);
                  props.updateHealthHistory(
                    response.id,
                    response.authorizationcptId
                  );
                  props.handleCloseAuthorizationFormByCPT();
                } else if (props.callingFrom == "notifcation") {
                  setcolumnID(response.authId);
                  props.updateNotificaton(
                    response.id,
                    response.notificationId,
                    response.createdBy
                  );
                  props.handleCloseNotification();
                }

                applyRefresh();
              },
            });
            setTimeout(() => {
              const alertBox = document.querySelector(".Alert");
              if (alertBox) {
                alertBox.style.zIndex = "180";
                alertBox.style.position = "fixed";
                alertBox.style.top = "20px";
                alertBox.style.left = "50%";
                alertBox.style.transform = "translateX(-50%)";
                alertBox.style.maxWidth = "90%";
              }
            }, 100);
          } else if (props.callingFrom == "update") {
            setcolumnID(response.authId);
            props.updateHealthHistory(
              response.id,
              response.authId,
              response.patientName
            );
            props.closevobpage();
          } else if (props.callingFrom == "dashboard") {
            setcolumnID(response.authId);
            props.updateHealthHistory(
              response.id,
              response.authId,
              response.patientName
            );
            props.closevobpage();
          } else {
            alert.error("Error uploading one or more documents.");
            setTimeout(() => {
              const alertBox = document.querySelector(".Alert");
              if (alertBox) {
                alertBox.style.zIndex = "1800";
                alertBox.style.position = "fixed";
                alertBox.style.top = "20px";
                alertBox.style.left = "50%";
                alertBox.style.transform = "translateX(-50%)";
                alertBox.style.maxWidth = "90%";
              }
            }, 100);
          }
        })
        .catch((error) => {
          setSpinner(false);
          console.log(error);
          setSubmitting(false);
          toast.error(`Error ${error.message}`, {
            type: "error",
          });
        });
      // return response
    });

    // axios
    //   .all(requests)
    //   .then(responses => {
    //     setSpinner(false)
    //     setOpen(false)
    //     setSubmitting(false)
    //     if (responses) {
    //       alert.success('Document uploaded successfully.', {
    //         type: 'success',

    //         onClose: () => {
    //           if(props.callingFrom == 'Pateint')
    //           {
    //             props.updateHealthHistory(responses.id, responses.authId )
    //             console.log('checktype',responses.id)
    //             props.handleClose2()
    //           }
    //           else if (props.callingFrom == 'Patient1')
    //           {
    //             props.updateHealthHistory(responses.id, responses.authId )
    //             console.log('checktype',responses.id)
    //             props.handleClose()
    //           }
    //           applyRefresh()

    //         }
    //       })
    //     } else {
    //       alert.error('Error uploading one or more documents.', {
    //         type: 'error'
    //       })
    //     }
    //   })
    //   .catch(error => {
    //     setSpinner(false)
    //     console.log(error)
    //     setSubmitting(false)
    //     alert.error(`Error ${error.message}`, {
    //       type: 'error'
    //     })
    //   })
  };
  const onSubmit = async (data) => {
    try {
      setSubmitting(true);

      if (EditTime) {
        if ((!DocumentName || !date) && type !== "lomn") {
          setdocError(true);
          setSubmitting(false);
          return;
        } else {
          setdocError(false);
        }
      }

      if (!EditTime) {
        if ((base64Data.length <= 0 || !date) && type !== "lomn") {
          setdocError(true);
          setSubmitting(false);
          return;
        } else {
          setdocError(false);
        }
      }

      if (type === "lomn" && !referringid) {
        setReferringError(true);
        setSubmitting(false);
        return;
      }
      if (sizeError) {
        setSizeError(true);
        return;
      }

      setSavedFiles([]);

      const postData = [];
      let totalLength = 0;
      let _authId =
        columnID > 0 ? columnID : props.callingFrom == "test" ? -10 : -9;
      let callingFrom = props.callingFrom;

      if (callingFrom == "notifcation") {
        _authId = 0;
      }
      if (callingFrom == "AuthorizationFormByCPT") {
        _authId = -9;
      }

      if (!EditTime) {
        if (type === "lomn" && base64Data.length <= 0) {
          const documentData = {
            patientId:
              props.callingFrom === "Patient" ||
              props.callingFrom === "Patient1"
                ? AutpattientID
                : props.callingFrom === "notifcation"
                ? patientId
                : props.callingFrom === "HealthRequest"
                ? AutpattientID
                : patientId,
            date: date,
            documentName: filename,
            base64:
              base64Data && base64Data.length > 0 && base64Data[0]
                ? base64Data[0]
                : "",
            authId: _authId,
            type: type,
            referringPhysiciansId: referringid,
            notificationId: props.callingFrom == "notifcation" ? -9 : 0,
            authorizationcptId:
              props.callingFrom == "AuthorizationFormByCPT" ? -9 : 0,
          };
          postData.push(documentData);
        } else {
          for (let i = 0; i < base64Data.length; i++) {
            const documentData = {
              patientId:
                props.callingFrom === "Patient" ||
                props.callingFrom === "Patient1"
                  ? AutpattientID
                  : props.callingFrom === "notifcation"
                  ? patientId
                  : props.callingFrom === "HealthRequest"
                  ? AutpattientID
                  : patientId,
              date: date,
              documentName: filename[i],
              base64: base64Data[i],
              authId: _authId,
              type: type,
              referringPhysiciansId: referringid,
              notificationId: props.callingFrom == "notifcation" ? -9 : 0,
              authorizationcptId:
                props.callingFrom == "AuthorizationFormByCPT" ? -9 : 0,
            };

            postData.push(documentData);
            totalLength += base64Data[i].length;
          }
        }
      } else {
        const documentData = {
          id: EditTimePayload.id,
          patientId:
            props.callingFrom === "Patient" || props.callingFrom === "Patient1"
              ? AutpattientID
              : props.callingFrom === "notifcation"
              ? patientId
              : props.callingFrom === "HealthRequest"
              ? AutpattientID
              : patientId,
          date: date || EditTimePayload.date,
          documentName: DocumentName,
          base64: base64Data[0],
          authId: EditTimePayload.authId,
          type: type,
          referringPhysiciansId:
            referringid || EditTimePayload.referringPhysiciansId,
          notificationId: props.callingFrom == "notifcation" ? -9 : 0,
          authorizationcptId:
            props.callingFrom == "AuthorizationFormByCPT" ? -9 : 0,
          fileurl: Fileurl,
        };
        postData.push(documentData);
      }

      // 🔹 yahan se sequence handle hoga
      let currentAuthId = _authId;
      let currentnotificationId = props.callingFrom == "notifcation" ? -9 : 0;

      // Step 1: Pehla document bhejna
      if (postData.length > 0) {
        const firstDoc = { ...postData[0], authId: currentAuthId };

        const config = {
          onUploadProgress: function (progressEvent) {
            const progress = Math.round(
              (progressEvent.loaded / totalLength) * 1.5
            );
            setTotalProgress(progress <= 100 ? progress : 100);
          },
          headers,
        };

        const firstResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocument?patientId=${patientId}`,
          firstDoc,
          config
        );

        if (firstResponse?.authId) {
          currentAuthId = firstResponse.authId; // ✅ ek hi baar update
          setcolumnID(firstResponse.authId);
        }
      if (firstResponse?.notificationId) {
              currentnotificationId = firstResponse.notificationId;
            }
        // 🔔 response handle karo
        if (firstResponse) {
          alert.success("Document uploaded successfully.", {
            type: "success",
            onClose: () => {
              if (props.callingFrom == "Patient") {
                props.updateHealthHistory(
                  firstResponse.id,
                  firstResponse.authId,
                  firstResponse.referringPhysiciansId,
                  firstResponse.createdBy,
                  firstResponse.createdDate
                );
                props.handleClose222();
              } else if (props.callingFrom == "HealthRequest") {
                props.updateHealthHistory(
                  firstResponse.id,
                  firstResponse.authId
                );
                props.handleClose222();
              } else if (props.callingFrom == "AuthorizationFormByCPT") {
                props.updateHealthHistory(
                  firstResponse.id,
                  firstResponse.authorizationcptId
                );
                props.handleCloseAuthorizationFormByCPT();
              } else if (props.callingFrom == "notifcation") {
                props.updateNotificaton(
                  firstResponse.id,
                  firstResponse.notificationId,
                  firstResponse.createdBy
                );
                props.handleCloseNotification();
              }
              applyRefresh();
            },
          });
        }
      }

      // Step 2: Baaki documents same authId ke sath bhejna
      for (let i = 1; i < postData.length; i++) {
        const documentData = { ...postData[i], authId: currentAuthId,notificationId:currentnotificationId ?? 0 };

        const config = {
          onUploadProgress: function (progressEvent) {
            const progress = Math.round(
              (progressEvent.loaded / totalLength) * 1.5
            );
            setTotalProgress(progress <= 100 ? progress : 100);
          },
          headers,
        };

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocument?patientId=${patientId}`,
          documentData,
          config
        );

        // 🔔 response handle karo
        if (response) {
          alert.success("Document uploaded successfully.", {
            type: "success",
            onClose: () => {
              if (props.callingFrom == "Patient") {
                props.updateHealthHistory(
                  response.id,
                  currentAuthId, // ✅ ab hamesha ek hi authId
                  response.referringPhysiciansId,
                  response.createdBy,
                  response.createdDate
                );
                props.handleClose222();
              } else if (props.callingFrom == "HealthRequest") {
                props.updateHealthHistory(response.id, currentAuthId);
                props.handleClose222();
              } else if (props.callingFrom == "AuthorizationFormByCPT") {
                props.updateHealthHistory(
                  response.id,
                  response.authorizationcptId
                );
                props.handleCloseAuthorizationFormByCPT();
              } else if (props.callingFrom == "notifcation") {
                props.updateNotificaton(
                  response.id,
                  response.notificationId,
                  response.createdBy
                );
                props.handleCloseNotification();
              }
              applyRefresh();
            },
          });
        }
      }

      setSpinner(false);
      setSubmitting(false);
      setOpen(false);
      handleClose();
    } catch (error) {
      setSpinner(false);
      setSubmitting(false);
      console.error(error);
      alert.error(`Error: ${error.message}`, { type: "error" });
    }
  };

  const download = (url, filename) => {
    console.log(url);
    console.log(filename);
    setSpinner(true);
    setSubmitting(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${url}`,
        {
          headers,
          responseType: "blob",
        }
      )
      .then((res) => {
        setopendocs(false);
        setSpinner(false);
        setSubmitting(false);
        console.log(res.data);
        fileDownload(res, filename);
      })
      .catch((err) => {
        setSubmitting(false);
        console.log(err);
      });
  };
  const [referring, setReferring] = useState([]);
  const practiceID = localStorage.getItem("default_paractice");
  const [openProviderModal, setOpenProviderModal] = useState(false);

  const handleOpenProviderModal = () => {
    setOpenProviderModal(true);
  };

  const handleCloseProviderModal = () => {
    setOpenProviderModal(false);
  };

  useEffect(() => {
    // POST request using axios inside useEffect React hook
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`,
        { headers }
      )
      .then((response) => {
        var ref = [];
        response.forEach((field) => {
          ref.push({
            label: `${field.lastName},${field.firstName} (NPI:${field.npi})`,
            value: field.id,
          });
        });
        setReferring(ref);
      })
      .catch((error) => {});

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [refresh, openProviderModal]);
  const handleRename = (index, newName) => {
    const updatedFilenames = [...filename];
    updatedFilenames[index] = newName; // Update the filename at the specific index
    setfilename(updatedFilenames);
  };
  useEffect(() => {
    if (type === "additionalInfo") {
      Swal.fire({
        icon: "warning",
        title: "Important Notice",
        html: "Please check all <b>mandatory boxes</b> and add <b>LOMN provider separately</b> if you are bulk file dropping.",
        confirmButtonText: "OK",
        didOpen: () => {
          const popup = document.querySelector(".swal2-popup");
          const container = document.querySelector(".swal2-container");
          if (popup) popup.style.zIndex = "2000";
          if (container) container.style.zIndex = "2000";
        },
      });
    }
  }, [type]);

  return (
    <div>
      <Dialog
        open={openFax}
        onClose={handleCloseFax}
        maxWidth="xs"
        sx={{ zIndex: 1760 }}
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}
      >
        {/* Header Section */}
        <Box display="flex" alignItems="center" gap={1.5} sx={{ px: 2, pt: 2 }}>
          <LocalPrintshopIcon color="primary" fontSize="large" />
          <Box>
            <Typography variant="h6" fontWeight={600}>
              Send Fax
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Enter the recipient fax number below.
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Fax Input Section */}
        <DialogContent>
          <TextField
            label="Fax Number"
            fullWidth
            margin="dense"
            value={faxNumber}
            onChange={handleFaxChange}
            placeholder="Enter 10-digit fax number"
            inputProps={{ maxLength: 10 }}
            InputLabelProps={{ shrink: true }}
            error={!!error}
            helperText={error}
          />
          <TextField
            label="Fax Subject"
            fullWidth
            margin="dense"
            placeholder="Enter Fax Subject"
            value={faxSubject}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setfaxSubject(e.target.value)}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseFax} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleSendFax}
            color="primary"
            variant="contained"
            endIcon={<SendIcon />}
            disabled={loadingFax}
          >
            Send Fax
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container>
        <Grid item xs={12}>
          {props.callingFrom == "test" && (
            <Box display="flex" gap={1}>
              <Button
                onClick={handleDownloadEachDocument}
                disabled={selectedPaths.length === 0}
                variant="contained"
                color="error"
              >
                <PrintIcon
                  fontSize="medium"
                  style={{
                    color: "white",
                    paddingRight: "4px",
                    paddingBottom: "2px",
                  }}
                ></PrintIcon>
                {downloadLoading
                  ? "Downloading..."
                  : "Download Selected Documents"}
              </Button>

              <Button
                onClick={handleOpenFax}
                disabled={selectedPaths.length === 0}
                variant="contained"
                color="primary"
                endIcon={<SendIcon />}
              >
                Fax Selected Documents
              </Button>
            </Box>
          )}

          <Grid item spacing={1} xs={12} sm={12} md={12} lg={12}>
            <Button
              className="Button"
              sx={{ mb: 2 }}
              onClick={handleOpenn}
              variant="gradient"
              color="info"
              size="small"
              style={{
                width: "150px",
                float: "right",
                height: "33px",
                marginTop: "10px",
                // backgroundColor: '#A574FD',
                color: "white",
                fontSize: "14px",
                marginRight: "15px",
              }}
            >
              <AddOutlinedIcon
                fontSize="medium"
                style={{
                  color: "white",
                  paddingRight: "4px",
                  paddingBottom: "2px",
                }}
              ></AddOutlinedIcon>
              Add New
            </Button>

            <Button
              className="Button"
              sx={{ mb: 2, marginRight: "20px", marginTop: "10px" }}
              onClick={(event) => {
                applyRefresh();
              }}
              style={{
                marginBottom: "10px",
                float: "right",
                marginLeft: "20px",
                width: "150px",
                height: "35px",
                // backgroundColor: '#A574FD',
                color: "white",
                fontSize: "14px",
              }}
            >
              <CachedOutlinedIcon
                fontSize="medium"
                style={{
                  color: "white",
                  marginRight: "1px",
                  paddingRight: "0px",
                  paddingBottom: "2px",
                }}
              ></CachedOutlinedIcon>
              Refresh
            </Button>
          </Grid>
          {/* {spinner ? (
              <FallbackSpinner
                style={{
                  width: '50px',
                  height: '50px',
                  position: 'absolute',
                  left: '50%',
                  top: '50%'
                  // marginLeft: '-25px'
                  // marginTop: '-25px'
                }}
              />
            ) : ( */}
          <>
            <Box mb={1}>
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ height: 428, width: "100%" }}
              >
                {docslist === null || docslist.length === 0 ? (
                  "No Record Found"
                ) : (
                  <DataGrid
                    rows={docslist}
                    columns={appointmentDocslist}
                    // headerHeight={37}
                    rowHeight={30}
                    sx={gridRowStyle}
                    pagination
                    // autoPageSize
                    pageSizeOptions={[25]} // Allows only 25 rows per page
                    initialState={{
                      pagination: {
                        paginationModel: { pageSize: 25, page: 0 },
                      },
                    }}
                  />
                )}
              </Grid>
            </Box>
          </>
          {/* )} */}
        </Grid>
      </Grid>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        sx={{ zIndex: 1760 }}
        onClose={handleClose}
        closeAfterTransition
        // BackdropProps={{
        //   timeout: 500
        // }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Grid container columnSpacing={0}>
              <Grid
                container
                spacing={0}
                style={{
                  backgroundColor: "#377562",
                }}
              >
                <Grid
                  item
                  xs={9}
                  style={{
                    fontWeight: 500,
                    backgroundColor: "#377562",
                    marginTop: "10px",
                  }}
                >
                  <Typography
                    style={{
                      fontWeight: "bold",
                      marginLeft: "7px",
                      fontSize: "18px",
                      color: "white",
                    }}
                  >
                    Upload patient document
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Button
                    onClick={handleClose}
                    variant="gradient"
                    // disabled={submitting}
                    style={{
                      marginTop: "10px",
                      float: "right",
                      marginBottom: "10px",
                      // width: "80px",
                      height: "35px",

                      color: "black",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}

                    // startIcon={<img src={SaveIcon} style={{marginTop:'-3px',marginRight:'-6px',}}/>}
                  >
                    <CancelOutlinedIcon
                      fontSize="medium"
                      style={{
                        color: "red",

                        paddingBottom: "2px",
                      }}
                    ></CancelOutlinedIcon>
                  </Button>
                </Grid>
              </Grid>
              {DocumentName && (
                <Grid
                  item
                  xs={11}
                  style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                >
                  <Typography style={{ color: "black" }}>
                    Document Name
                  </Typography>
                  <TextField
                    size="small"
                    value={DocumentName}
                    onChange={(e) => {
                      setDocumentName(e.target.value);
                    }}
                    width="auto"
                    fullWidth
                    placeholder="Select date"
                  />
                </Grid>
              )}
              <Grid
                item
                xs={11}
                style={{ width: 250, marginTop: 15, marginLeft: 15 }}
              >
                <Typography style={{ color: "black" }}>Date</Typography>
                <TextField
                  type="date"
                  size="small"
                  value={date}
                  onChange={(e) => {
                    setdate(e.target.value);
                  }}
                  width="auto"
                  fullWidth
                  placeholder="Select date"
                />
              </Grid>
              {filename.length > 0 && (
                <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
                  <h4>Uploaded Files (Edit Names Below):</h4>
                  {filename.map((name, index) => (
                    <Grid
                      container
                      spacing={2}
                      key={index}
                      style={{ marginBottom: 10 }}
                    >
                      <Grid item xs={8}>
                        <TextField
                          fullWidth
                          label={`File ${index + 1}`}
                          value={name}
                          size="small"
                          onChange={(e) => handleRename(index, e.target.value)}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}
              {type == "lomn" ? (
                <>
                  <Grid
                    item
                    xs={8}
                    style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                  >
                    <Typography style={{ color: "black" }}>
                      Referring Provider (select from Dropdown)
                    </Typography>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid
                    item
                    xs={6}
                    style={{ width: 250, marginTop: 15, marginLeft: 15 }}
                  ></Grid>
                </>
              )}
              {type == "lomn" ? (
                <>
                  <Grid item xs={8} style={{ width: 250, marginLeft: 15 }}>
                    <Controller
                      name="referringPhysiciansId"
                      // {...register("practiceId")}
                      control={control}
                      render={({ field }) => (
                        <ReactSelect
                          default
                          size="small"
                          style={{
                            width: "22em",
                          }}
                          placeholder="Type Here to Search"
                          value={referring.find(
                            (option) => option.value === referringid
                          )}
                          onChange={(e) => {
                            setValue("referringPhysiciansId", e.value);
                            setReferringid(e.value);
                            setReferringError(false);
                            // setProvName("provider_id", value.value);
                            // setProviders(value.value);
                          }}
                          options={referring}
                        />
                      )}
                    />
                    {referringError && (
                      <Typography style={{ color: "red", marginLeft: 15 }}>
                        Please select a referring provider.
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={0.2}></Grid>
                  <Grid item xs={3.2}>
                    <Button
                      className="Button"
                      onClick={handleOpenProviderModal}
                      variant="contained"
                    >
                      Add New Provider
                    </Button>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={6} style={{ width: 250 }}></Grid>
                </>
              )}
            </Grid>

            <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
              <Button className="Button" variant="contained" component="label">
                Upload
                <input
                  type="file"
                  name="file"
                  onInput={(e) => handleChangeforfile(e.target.files)}
                  style={{ display: "none" }}
                  multiple
                />
              </Button>
            </Grid>

            <Grid item xs={12} style={{ marginTop: 15, marginLeft: 15 }}>
              <FileUploader
                multiple={true}
                handleChange={handleChangeforfile}
                name="file"
              />
            </Grid>
            {sizeError && (
              <Grid item xs={12} style={{ marginTop: 15, color: "red" }}>
                Please select files smaller than 10 MB
              </Grid>
            )}
            <Grid item xs={12} style={{ marginTop: "5px", marginLeft: 15 }}>
              <Typography>
                {" "}
                To Upload files Please click on upload button and then Save it
              </Typography>
            </Grid>
            {/* <Grid item xs={12} style={{ marginTop: '5px', marginLeft: 15 }}>
              <>
                {filename.length > 0 && (
                  <div>
                    <h2>Uploaded Files:</h2>
                    <div style={{ height: '100px', width: '100%', }}>
                      <ul>
                        {filename.map((name, index) => (
                          <>
                            {/* <li key={name}>{name} </li> 
                            <li>
                              <Typography key={index} variant='body1' color='black'>
                                {name} {savedFiles.includes(index) && '✓'}
                              </Typography>
                            </li>
                          </>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </>
            </Grid> */}
            <Grid item xs={12} style={{ marginTop: "5px" }}>
              {file && <p>Currently uploading: {file.name}</p>}
            </Grid>
            <Grid>
              {docError ? (
                <Typography style={{ color: "red" }}>
                  Please select document and date
                </Typography>
              ) : null}
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500 }}>
              {submitting ? (
                <Grid>
                  {/* <LoadingButton loading loadingIndicator='Saving…' color='primary' variant='contained'>
                    Fetch data
                  </LoadingButton> */}

                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>

                  <Typography variant="bold" component="div" color="#ba000d">
                    Please wait your data is being saved..
                  </Typography>
                </Grid>
              ) : (
                ""
              )}
              <Button
                className="Button"
                variant="contained"
                style={{ float: "right", width: "80", marginBottom: "5px" }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                className="Button"
                variant="contained"
                color="primary"
                onClick={handleSubmit(onSubmit)}
                disabled={submitting}
                style={{
                  float: "right",
                  width: "80px",
                  marginRight: "5px",
                  marginLeft: "5px",
                }}
              >
                Save
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={handleClose}
        open={opendocs}
        sx={{
          zIndex: 1760,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            p: { xs: 2, sm: 3, md: 4 },
            width: { xs: "90%", sm: "80%", md: "70%", lg: "60%" },
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Grid container spacing={1} alignItems="center">
            {/* Title */}
            <Grid item xs={12} sm={7} md={9}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 500,
                  backgroundColor: "#377562",
                  mb: 1,
                  color: "white",
                  borderRadius: 1,
                  p: 1,
                  textAlign: "center",
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                }}
              >
                {FullDocName}
              </Typography>
            </Grid>

            {/* Download Button */}
            <Grid item xs={8} sm={3} md={2}>
              {submitting ? (
                <LoadingButton
                  loading
                  loadingIndicator="Downloading"
                  color="primary"
                  variant="contained"
                  fullWidth
                >
                  Fetch data
                </LoadingButton>
              ) : (
                <Button
                  className="Button"
                  size="small"
                  startIcon={<Download />}
                  onClick={() => download(`${urldownload}`, FullDocName)}
                  variant="contained"
                  disabled={submitting}
                  sx={{
                    color: "white",
                    backgroundColor: "#377562",
                    "&:hover": { backgroundColor: "#2f5c4e" },
                    width: "100%",
                  }}
                >
                  Download
                </Button>
              )}
            </Grid>

            {/* Close Icon */}
            <Grid item xs={4} sm={2} md={1} textAlign="right">
              <CancelOutlinedIcon
                onClick={handleClose}
                fontSize="large"
                sx={{
                  color: "red",
                  cursor: "pointer",
                }}
              />
            </Grid>

            {/* File Preview */}
            <Grid item xs={12} sx={{ textAlign: "center"}}>
              {["jpg", "jpeg", "png"].includes(DocName?.toLowerCase()) ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      mb: 1,
                      color: "#333",
                    }}
                  >
                    If the content does not display below,{" "}
                    <span
                      onClick={() =>
                        window.open(
                          urlFile,
                          "_blank",
                          "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=200,width=1000,height=700"
                        )
                      }
                      style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      click here to open in a new window
                    </span>
                    .
                  </Typography>

                  <Box
                    component="img"
                    src={urlFile}
                    alt="Document Preview"
                    sx={{
                      maxWidth: "100%",
                      height: "auto",
                      border: "4px solid #ddd",
                      borderRadius: 2,
                      maxHeight: { xs: 300, sm: 400, md: 500 },
                      objectFit: "contain",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    }}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f9f9f9",
                    borderRadius: 2,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 1,
                      textAlign: "center",
                      color: "#333",
                    }}
                  >
                    If the document preview doesn’t load,{" "}
                    <span
                      onClick={() =>
                        window.open(
                          urlFile,
                          "_blank",
                          "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=200,width=1000,height=700"
                        )
                      }
                      style={{
                        color: "#1976d2",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      click here to open in a new window
                    </span>
                    .
                  </Typography>

                  <Box
                    component="iframe"
                    src={urlFile}
                    sx={{
                      width: "100%",
                      height: { xs: 300, sm: 400, md: 500 },
                      border: "4px solid #ddd",
                      borderRadius: 2,
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    }}
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openProviderModal}
        sx={{ zIndex: 1760 }}
        onClose={handleCloseProviderModal}
        closeAfterTransition
      >
        <ContantsRegistration
          callingFrom={"Documents"}
          handleCloseProviderModal={handleCloseProviderModal}
        ></ContantsRegistration>
      </Modal>
    </div>
  );
};
export default Documents;
